import { Col, Row, Table } from "antd";
import { useState } from "react";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ModalConvocatorias } from "./ModalConvocatorias";
import "./style.scss";

export const EnviarNotificaciones = () => {
  const [openModal, setOpenModal] = useState(false);
  const [tipoConvocatoria, setTipoConvocatoria] = useState(0);
  const [tipoNotificacion, settipoNotificacion] = useState("");

  const openNotification = (x: any) => {
    settipoNotificacion(x.tipoNotificacion);
    setTipoConvocatoria(x.tipoConvocatorias);
    setOpenModal(!openModal);
  };
  const routes = [{ nombre: "Notificaciones" }, { nombre: "Enviar notificaciones" }];

  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c6">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Enviar notificaciones
        </div>

        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Convocatorias-participantes artistas
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="col-12">
                  {data1.map((x,i) => (
                    <div key={i}
                      className={
                        x.color
                          ? "row container__color"
                          : "row container__no__color"
                      }
                    >
                      <div className="col-12 col-md-6">{x.title}</div>
                      <div className="col-12 col-md-6 d-flex justify-content-md-end">
                        <div
                          className="font-size-12px font-color-051923bf"
                          style={{ cursor: "pointer" }}
                          onClick={() => openNotification(x)}
                        >
                          Enviar Notificaciones
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Notificaciones BEPS
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="col-12">
                  {data2.map((x,i) => (
                    <div key={i}
                      className={
                        x.color
                          ? "row container__color"
                          : "row container__no__color"
                      }
                    >
                      <div className="col-12 col-md-6 item__table">
                        {x.title}
                      </div>
                      <div className="col-12 col-md-6 col-lg-6 d-flex justify-content-md-end">
                        <div
                          className="font-size-12px font-color-051923bf"
                          style={{ cursor: "pointer" }}
                          onClick={() => openNotification(x)}
                        >
                          Enviar Notificaciones
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Postulación al banco de jurados
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="col-12">
                  {data3.map((x,i) => (
                    <div key={i}
                      className={
                        x.color
                          ? "row container__color"
                          : "container__no__color"
                      }
                    >
                      <div className="col-12 col-md-6 item__table">
                        {x.title}
                      </div>
                      <div className="col-12 col-md-6 d-flex justify-content-md-end">
                        <div
                          className="font-size-12px font-color-051923bf"
                          style={{ cursor: "pointer" }}
                          onClick={() => openNotification(x)}
                        >
                          Enviar Notificaciones
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openModal && (
        <ModalConvocatorias
          openModal={openModal}
          setOpenModal={setOpenModal}
          tipoConvocatoria={tipoConvocatoria}
          tipoNotificacion={tipoNotificacion}
        />
      )}
    </div>
  );
};

const data1 = [
  {
    title: "1. Informe de inscritos",
    color: true,
    tipoConvocatorias: 1,
    tipoNotificacion: "Informe",
  },
  {
    title: "2. Primer informe de verificación de documentos",
    color: false,
    tipoConvocatorias: 1,
    tipoNotificacion: "Primer informe",
  },
  {
    title: "3. Segundo informe de verificación",
    color: true,
    tipoConvocatorias: 1,
    tipoNotificacion: "Segundo informe",
  },
  {
    title: "4. Informe de evaluación",
    color: false,
    tipoConvocatorias: 1,
    tipoNotificacion: "Informe de evaluación",
  },
  {
    title: "5. Resolución de otorgamiento",
    color: true,
    tipoConvocatorias: 1,
    tipoNotificacion: "Resolución de otorgamiento",
  },
  {
    title: "6. Subsanación",
    color: false,
    tipoConvocatorias: 1,
    tipoNotificacion: "Subsanación",
  },
];

const data2 = [
  {
    title: "1. Informe de inscritos",
    color: true,
    tipoConvocatorias: 3,
    tipoNotificacion: "Informe",
  },
  {
    title: "2. Subsanación",
    color: false,
    tipoConvocatorias: 3,
    tipoNotificacion: "Subsanación",
  },
  {
    title: "3. Inscripción",
    color: true,
    tipoConvocatorias: 3,
    tipoNotificacion: "inscripción",
  },
];

const data3 = [
  {
    title:
      "1. Informe de evaluación para conformación de la base de jurados-notificación",
    color: true,
    tipoConvocatorias: 2,
    tipoNotificacion: "Información",
  },
  {
    title:
      "2. Inscripción",
    color: true,
    tipoConvocatorias: 2,
    tipoNotificacion: "inscripción",
  },
  {
    title:
      "3. Proyectos a evaluar",
    color: true,
    tipoConvocatorias: 2,
    tipoNotificacion: "asignacion",
  },
];
